// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__2Ng3D","content":"styles_content__3KM5B","selectAll":"styles_selectAll__3R2dD"};